import { usersSetViewModeEvent } from './users-set-view-mode-event';
import { usersPostPageResizeEvent } from './users-post-page-resize-event';
import { usersOpenPostPageEditorEvent } from './users-open-post-page-editor-event';
import { usersPageOpenedEvent } from '../../common/bi-events/users-events/users-page-opened-event';

export const usersEventMap = {
  ...usersSetViewModeEvent,
  ...usersPostPageResizeEvent,
  ...usersPageOpenedEvent,
  ...usersOpenPostPageEditorEvent,
};
